import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@/shared/api/reauth.api';
import { AppStoreTag } from '@/shared/constants/app-store-tag.constant';

export const organizationServiceApi = createApi({
	reducerPath: 'organization service',
	tagTypes: [AppStoreTag.OrganizationNodes, AppStoreTag.OrganizationMembers, AppStoreTag.OrganizationTree],
	baseQuery: baseQueryWithReauth(`${API_URL}/hdata-user/api/v3`),
	endpoints: () => ({}),
});
